import { useEffect, useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

export default function Testimonials({ data }) {
  const items = data?.items || [];
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6500);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;

  return (
    <section id="testimonials" data-testid="section-testimonials" className="section-pad bg-[#0B1736] relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-20" />
      <div className="container-pad relative">
        <div className="max-w-2xl text-white">
          <div className="kicker !text-teal-300">{data.kicker || "Our Feedback"}</div>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mt-4">{data.title}</h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl relative">
              <Quote className="absolute -top-5 -left-5 w-12 h-12 text-teal-500" fill="currentColor" />
              <div className="flex items-center gap-1 text-yellow-500">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-500" />)}
              </div>
              <p className="mt-5 text-lg md:text-xl text-slate-700 leading-relaxed">
                {items[idx].quote}
              </p>
              <div className="mt-7 flex items-center justify-between">
                <div>
                  <div className="font-bold text-[#0F172A]">{items[idx].name}</div>
                  <div className="text-xs uppercase tracking-wider text-teal-700">{items[idx].role}</div>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setIdx((i) => (i - 1 + items.length) % items.length)}
                    className="w-10 h-10 rounded-full border border-slate-200 hover:bg-slate-50 grid place-items-center"
                    data-testid="testimonial-prev"
                    aria-label="prev"
                  >
                    <ChevronLeft className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => setIdx((i) => (i + 1) % items.length)}
                    className="w-10 h-10 rounded-full bg-[#1E3A8A] text-white hover:bg-teal-600 grid place-items-center"
                    data-testid="testimonial-next"
                    aria-label="next"
                  >
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 grid gap-3">
            {items.slice(0, 4).map((t, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`text-left p-4 rounded-2xl border transition ${
                  idx === i ? "bg-white/15 border-teal-400/50 text-white" : "bg-white/5 border-white/10 text-slate-300 hover:bg-white/10"
                }`}
                data-testid={`testimonial-thumb-${i}`}
              >
                <div className="text-xs uppercase tracking-wider text-teal-300">{t.role}</div>
                <div className="font-semibold mt-0.5">{t.name}</div>
                <div className="text-xs mt-1 line-clamp-2 opacity-80">{t.quote}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
